import { MapTo } from "@adobe/aem-react-editable-components";
import { AccountDashboardBanner } from "@jti/loyalty";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const accountDashboardBannerEditConfig = {
    emptyLabel: "AccountDashboardBanner",
    isEmpty: (props) => !props.title || !props.text || !props.background,
    getProps: (props) => ({
        title: props.title,
        text: props.text,
        background: props.background,
        showCurrentTier: props.showCurrentTier,
        componentId: props.cqPath?.slice(props.cqPath.lastIndexOf("/") + 1, props.cqPath.length),
        tiers: props.tiers,
    }),
};
export default MapTo("loyalty/components/accountdashboardbanner")(withAemAuthoring(AccountDashboardBanner, accountDashboardBannerEditConfig));
